import { LinkPresentationProps } from "@insite/mobius/Link";
import { TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

export interface ButtonStyles {
    iconPrimaryLightBackground: LinkPresentationProps;
    iconPrimaryDarkBackground: LinkPresentationProps;
    iconSecondryLightBackground: LinkPresentationProps;
    iconSecondryDarrkBackground: LinkPresentationProps;

}

export const buttonStyles: ButtonStyles = {
    iconPrimaryLightBackground: {
        typographyProps: {
            color: "#FFF !important",
            weight: TYPOGRAPHY.weight.bold,
            size: TYPOGRAPHY.size.small,
            css: css`
                font-family: ${TYPOGRAPHY.fontFamily.base};
                font-style: normal;
                line-height: normal;
                color: #FFF;
            `,
        },
        css: css`
         svg path{
                stroke: #FFF;
            }
        outline-color: transparent !important;
        background-color: #323132;
        height: 40px;
        padding: 0px 25.5px;
        border: none;
        &:disabled{
            border: none;
            background-color: #F3F3F3;
        }
        `,
    },
    iconPrimaryDarkBackground: {
        typographyProps: {
            color: "#323132 !important",
            weight: TYPOGRAPHY.weight.bold,
            size: TYPOGRAPHY.size.small,
            css: css`
                        font-family: ${TYPOGRAPHY.fontFamily.base};
                        font-style: normal;
                        line-height: normal;
                        color: #323132;
                    `,
        },
        css: css`
            svg path{
                stroke: #323132;
            }
                outline-color: transparent !important;
                background-color: #FFFFFF;
                height: 40px;
                padding: 0px 25.5px;
                border: none;
                &:disabled{
                    border: none;
                    background-color: #545454;
                }
                `,
    },
    iconSecondryLightBackground: {
        typographyProps: {
            color: "#323132 !important",
            weight:TYPOGRAPHY.weight.bold,
            size: TYPOGRAPHY.size.small,
            css: css`
                font-family: ${TYPOGRAPHY.fontFamily.base};
                font-style: normal;
                line-height: normal;
                color: #323132;
            `,
        },
        css: css`
         svg path{
                stroke: #323132;
            }
        outline-color: transparent !important;
        height: 40px;
        padding: 0px 20.5px;
        border: 2px solid #323132;
        &:disabled{
            border: 2px solid #F3F3F3;
            color: #F3F3F3;
        }
        `,
    },
    iconSecondryDarrkBackground: {
        typographyProps: {
            color: "#fff !important",
            weight: TYPOGRAPHY.weight.bold,
            size: TYPOGRAPHY.size.small,
            css: css`
                font-family: ${TYPOGRAPHY.fontFamily.base};
                font-style: normal;
                line-height: normal;
                color: #fff;
            `,
        },
        css: css`
         svg path{
                stroke: #fff;
            }
        outline-color: transparent !important;
        height: 40px;
        padding: 0px 25.5px;
        border: 2px solid #fff;
        &:disabled{
            border: 2px solid #545454;
            color: #545454;
        }
        `,
    },

};